<div
	[formGroup]="digitalEquipmentFormGroup"
	class="form-field-container"
>
	<img
		src="assets/img/Leitkegel.png"
		alt="Leitkegel"
		height="30px"
	/>
	<div
		[ngClass]="cssClass"
		class="equipment-wrapper"
	>
		<input
			[ngClass]="cssClass"
			matInput
			formControlName="digitalEquipmentControl"
			[readonly]="!canEditDigitalEquipment"
			type="tel"
		/>
	</div>
</div>
